export default "__VITE_ASSET__GJkwj8tJ__"